<template>
  <div class="nav-wrap" :class="isTop ? 'navTop' : ''">
      <img @click="back" class="back-icon" src="@/assets/images/ico_fanhui@2x.png" alt="">
      <div class="title">{{ title }}
        <slot name="titleMode"></slot>
      </div>
  </div>
</template>
<script>
export default {
 data() {
    return {
    }
 },
 props:['title', 'isTop'],
 created(){
 },
 computed:{
 },
 methods:{
  back(){
    this.$emit('handleBack')
  }
 },
}
</script>
<style lang="scss" scoped>
.nav-wrap{
box-sizing: border-box;
height: 30px;
line-height: 30px;
display: flex;
align-items: center;
// padding-top: 10px;
.back-icon{
  width: 16px;
  height: 16px;
  line-height: 30px;
}
.title {
  width: 300px;
  // transform: translateX(-16px);
  font-size: 15px;
  font-weight: 600;
  color: #202020;
  margin: auto;
  padding-right: 16px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  
}
}
.navTop {
height: 40px;
padding-top: 0;
.back-icon {
  line-height: 40px;
}
}
</style>
